var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.495 1.082a5.414 5.414 0 00-5.412 5.417 5.414 5.414 0 005.412 5.416A5.42 5.42 0 0011.917 6.5a5.42 5.42 0 00-5.422-5.417zm.005 9.75a4.332 4.332 0 01-4.333-4.333A4.332 4.332 0 016.5 2.165 4.332 4.332 0 0110.833 6.5 4.332 4.332 0 016.5 10.832zm.27-7.042h-.812v3.25l2.844 1.707.406-.667-2.437-1.446V3.79z",
    fill: "#EA580C"
  })));
}
export default SvgClock;